<template>
  <div
    class="w-max-content w-max cursor-pointer text-gray-900 hover:text-gray-600 relative"
  >
    <div
      v-if="$can(constants.PERMISSION_MODELE_DE_PAGE_EDITER)"
      @click="dropdown = true"
      @click.stop
      class="relative w-full flex items-center justify-center"
    >
      <span class="plus-button 2xl:h-10 2xl:w-10 dropdown-menu">
        <icon
          name="plus"
          class="dropdown-menu"
        />
      </span>
      <div class="dropdown-menu text-lg ml-3 inline-block font-normal">
        Ajouter un champ
      </div>
      <div class="text-teal-600 inline-block ml-2 dropdown-menu">
        <icon name="chevron-down" />
      </div>
    </div>
    <!-- BEGIN Menu dropdown kind of field -->
    <transition
      enter-active-class="ease-out duration-150"
      enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      enter-to-class="opacity-100 translate-y-0 sm:scale-100"
      leave-active-class="ease-in duration-200"
      leave-class="opacity-100 translate-y-0 sm:scale-100"
      leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    >
      <div
        class="z-20 absolute left-20 md:left-0 lg:left-20 mt-1 w-max-content w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-base font-normal p-4 flex flex-col md:flex-row"
        v-if="dropdown"
        v-click-outside="forceHide"
      >
        <div
          class="cursor-pointer w-48 hover:bg-indigo-600 hover:bg-opacity-25 rounded p-2"
          @click="$emit('addText')"
        >
          <p class="text-indigo-600 uppercase text-sm font-semibold">
            Champ texte
          </p>
          <br>
          <input-text
            class="w-full cursor-pointer"
            libelle="Libellé du champ"
            placeholder="Champ texte"
            disabled
          />
        </div>
        <div class="w-15 text-pink-600 text-base text-center self-center">
          OU
        </div>
        <div
          class="relative cursor-pointer w-48 hover:bg-indigo-600 hover:bg-opacity-25 rounded p-2"
          @click="$emit('addMulti')"
        >
          <p class="text-indigo-600 uppercase text-sm font-semibold">
            Champ multi critères
          </p>
          <br>
          <input-select
            class="w-full cursor-pointer"
            libelle="Libellé du champ"
            disabled
            :datas="[]"
            placeholder="Critères"
          />
        </div>
        <div class="w-15 text-pink-600 text-base text-center self-center">
          OU
        </div>
        <div
          class="cursor-pointer w-48 hover:bg-indigo-600 hover:bg-opacity-25 rounded p-2"
          @click="$emit('addTextArea')"
        >
          <p class="text-indigo-600 uppercase text-sm font-semibold">
            Champ commentaire
          </p>
          <br>
          <input-text-area
            class="w-full cursor-pointer"
            libelle="Libellé du champ"
            placeholder="Commentaire"
            disabled
            size="1"
          />
        </div>
      </div>
    </transition>
    <!-- END Menu dropdown kind of field -->
  </div>
</template>
<script>
import Icon from '../../components/Icon';
import InputSelect from '../../components/Inputs/InputSelect';
import InputText from '../../components/Inputs/InputText';
import InputTextArea from '../../components/Inputs/InputTextArea';
import Constants from '../../constants';
import ClickOutside from 'vue-click-outside';

export default {
  name: 'AddFieldButton',
  components: { Icon, InputSelect, InputText, InputTextArea },
  emits: ['addText', 'addMulti', 'addTextArea'],
  data() {
    return {
      constants: Constants,
      dropdown: false,
    };
  },
  methods: {
    forceHide(e) {
      if (e.target.classList.contains('dropdown-menu')) {
        this.dropdown = !this.dropdown;
      } else {
        if (this.dropdown) {
          this.dropdown = false;
        }
      }
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>